import React from "react";

const SvgDelete = props => (
  <svg viewBox="0 0 469.333 469.333" {...props}>
    <path d="M426.667 0h-384C19.146 0 0 19.135 0 42.667v384c0 23.531 19.146 42.667 42.667 42.667h384c23.521 0 42.667-19.135 42.667-42.667v-384C469.333 19.135 450.188 0 426.667 0zm-88.461 308.043c4.167 4.165 4.167 10.919 0 15.085l-15.081 15.082c-4.167 4.165-10.919 4.165-15.086 0l-73.374-73.374-73.374 73.374c-4.167 4.165-10.919 4.165-15.086 0l-15.081-15.082c-4.167-4.165-4.167-10.919 0-15.085l73.374-73.375-73.374-73.374c-4.167-4.165-4.167-10.919 0-15.085l15.081-15.082c4.167-4.165 10.919-4.165 15.086 0l73.374 73.374 73.374-73.374c4.167-4.165 10.919-4.165 15.086 0l15.081 15.082c4.167 4.165 4.167 10.919 0 15.085l-73.374 73.374 73.374 73.375z" />
  </svg>
);

export default SvgDelete;
